/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGrassIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-grass"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.82 21.2Q1.27 21.2 0.89 20.81Q0.5 20.43 0.5 19.88Q0.5 19.32 0.89 18.94Q1.27 18.55 1.82 18.55L7.03 18.55Q6.6 17.13 5.72 15.9Q4.85 14.68 3.6 13.75Q2.85 13.2 3.17 12.57Q3.5 11.95 4.5 12.15Q7.72 12.75 9.86 15.28Q12 17.8 12 21.2ZM14 21.2Q14 20 13.76 18.95Q13.53 17.9 13.07 16.88Q14.15 14.93 15.85 13.71Q17.55 12.5 19.57 12.15Q20.52 11.97 20.85 12.59Q21.18 13.2 20.4 13.78Q19.15 14.7 18.27 15.94Q17.4 17.18 17 18.55L22.18 18.55Q22.73 18.55 23.11 18.94Q23.5 19.32 23.5 19.88Q23.5 20.43 23.11 20.81Q22.73 21.2 22.18 21.2ZM12.07 15.05Q11.78 12.18 13.21 9.74Q14.65 7.3 17.15 6.08Q17.98 5.65 18.46 6.14Q18.95 6.63 18.3 7.38Q17.55 8.28 16.96 9.26Q16.38 10.25 16.13 11.3Q14.85 11.9 13.81 12.9Q12.78 13.9 12.07 15.05ZM10.55 13.2Q10.07 12.7 9.46 12.24Q8.85 11.78 8.47 11.57Q8.47 11.4 8.51 11.04Q8.55 10.68 8.55 10.5Q8.55 9.22 8.3 8.05Q8.05 6.88 7.63 5.75Q7.3 4.9 7.86 4.59Q8.43 4.28 9.07 4.92Q9.9 5.78 10.57 6.86Q11.25 7.95 11.7 9.3Q11.22 10.15 10.95 11.18Q10.68 12.2 10.55 13.2Z" fill={color} />
    </svg>
  );
}
